import axios from 'axios'
import { Toast } from 'vant'
import eventBus from '@/event_bus'
import md5 from 'js-md5'
import { getRequest } from '@/utils'

let baseURL = 'api/v1'
const pathname = location.pathname
const path = pathname.split('static')
if (path && path[0]) {
    baseURL = path[0] + baseURL
} else {
    baseURL = '/' + baseURL
}

// create an axios instance
const service = axios.create({
    baseURL, // process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        // config.headers['token'] = getToken()
        // }

        if (config.url !== 'oauth/lynk') {
            config.headers['token'] = sessionStorage.getItem('customer-token')
            config.headers['openid'] = sessionStorage.getItem('customer-openid')
        }
        const ua = navigator.userAgent
        const isApp = ua.indexOf('x-cordova-platform') > -1
        const isMiniProgram = window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1
        const channel = getRequest().channel
        if (['jh_app', 'jhmall_app', 'jhcollection_app'].includes(channel)) {
            config.headers['equipment'] = 'geometry_app'
        } else if (isApp) {
            config.headers['equipment'] = 'app'
        } else if (isMiniProgram) {
            config.headers['equipment'] = 'wxapp'
        }

        let srcParams = config.method === 'get' ? config.params : config.data
        let signParams = {
            appid: 'h5',
            timestamp: new Date().getTime(),
            noncestr: getUUID(32),
            secret: '8vEFSVAXFB8Nt79iCpxWK7'
        }
        let sign = generateSign(signParams, srcParams)
        config.headers['appid'] = signParams.appid
        config.headers['timestamp'] = signParams.timestamp
        config.headers['noncestr'] = signParams.noncestr
        config.headers['sign'] = sign

        const uid = eventBus.uid
        if (uid) {
            config.headers['chat-user-id'] = uid
        }

        return config
    },
    error => {
        // do something with request error
        // eslint-disable-next-line
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const code = response.data.code
        if (code !== 0) {
            const errorMsg = response.data.msg
            const url = response.config.url
            if (url == '/api/v1/chat/user/id') {
                Toast.clear()
                Toast({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '无访问权限'
                })
            } else if (code === 500001) {
                return Promise.reject(response)
            } else if (code !== 800001) {
                Toast(errorMsg)
            }
            return Promise.reject(response)
        }
        return response.data.data
        // if the custom code is not 20000, it is judged as an error.
        /* if (res.code !== 20000) {
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // to re-login
                MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                })
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        } */
    },
    error => {
        // eslint-disable-next-line
        console.log(error) // for debug
        if (error.message === 'Network Error') {
            Toast('网络错误')
        } else if (error.message.indexOf('timeout') > -1) {
            Toast('请求超时')
        } else if (error.message.indexOf('401') > -1) {
            Toast('非法请求，消息发送失败')
        } else {
            try {
                Toast(error.response.data.msg)
            } catch (e) {
                console.log(e)
                Toast(error.message)
            }
        }
        return Promise.reject(error)
    }
)

/** 签名方案文档：https://www.tapd.cn/45874634/personal_documents/view/1145874634001000369 **/

function getUUID (num = 32) {
    let times = num / 4
    if (num % 4 !== 0) {
        console.error('uuid的位数应该为4的倍数')
        return
    }
    let str = ''
    for (let i = 0; i < times; i++) {
        str += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return str
}

function generateSign (signParams = {}, srcParams = {}) {
    // 过滤掉数字和对象类型
    let basicClass = ['number', 'string', 'boolean', 'null']
    let str = ''
    Object.keys(srcParams)
        .sort()
        .map(k => {
            let val = srcParams[k]
            let type = typeof val
            if (basicClass.some(n => n === type)) {
                switch (srcParams[k]) {
                    case true:
                        str += `${k}=1&`
                        break
                    case false:
                        str += `${k}=0&`
                        break
                    case null:
                        str += `${k}=''&`
                        break
                    default:
                        str += `${k}=${val === '' ? '' : val}&`
                        break
                }
            }
        })
    str = `${str||'&'}appid=${signParams.appid}&noncestr=${signParams.noncestr}&timestamp=${signParams.timestamp}&secret=${signParams.secret}`
    return md5(str)
}

export default service
